import $ from 'jquery'
import store from 'store2'

import convertArrayToCSV from 'convert-array-to-csv'

import { button } from '../../../../component/component'

import generateSequence from '../../lib/generateSequence'
import refreshCdn from '../../lib/refreshCdn'
import refreshReports from '../../lib/refreshReports'

export default function(o){

  var lastSequence =
    _.find(o.data.antiArchive.sequences,function(sequence){
      return sequence.tag == 'full-sequence'
    })

  var date = lastSequence.date

  var menu = null

  var dataServer = o.store('dataServer')
  var videoServer = o.store('videoServer')

  var generateDownloadButton = function(quality){
    var token = o.store('token')
    var download = lastSequence.files[quality]
    var markers = lastSequence.markers.length
    var href = `${videoServer}download/sequence/${quality}/${download}?token=${token}`
    var label = `${quality}p ${date} (${markers} markers)`
    var downloadButton =
      $('<a>')
      .append(
        button(label,'fi-download')
        .css({
          display: 'block',
        })
      )
      .attr({
        download: download,
        href: href,
      })
      .css({
        textDecoration: 'none',
      })
      .click(
        function(){
          menu.remove()
        }
      )
    return downloadButton
  }

  var generateDownloadCsvButton = function(file){
    var token = o.store('token')
    var href = `${dataServer}downloadReports/${file}.csv?token=${token}`
    var downloadButton =
      $('<a>')
      .append(
        button(file,'fi-download')
        .css({
          display: 'block',
        })
      )
      .attr({
        download: file,
        href: href,
      })
      .css({
        textDecoration: 'none',
      })
      .click(
        function(){
          menu.remove()
        }
      )
    return downloadButton
  }

  var generateDownloadCsvDataButton = function(){
    var data = _.map(o.currentData, function(item){
      var o = {}
      for (let index = 0; index < item.columns.length; index++) {
        var column = item.columns[index];
        o[column.id] = column.value || '-'
      }
      return o
    })
    var file = 'omb_table_data_export.csv'
    var csv = convertArrayToCSV(data, {separator: '\t'})
    var href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`
    var downloadButton =
      $('<a>')
      .append(
        button('download current table data','fi-download')
        .css({
          display: 'block',
        })
      )
      .attr({
        download: file,
        href: href,
      })
      .css({
        textDecoration: 'none',
      })
      .click(
        function(){
          menu.remove()
        }
      )
    return downloadButton
  }

  var generateRefresh = function(){
    var dateButton =
      button('generate full sequence','fi-refresh')
      .css({
        display: 'block',
      })
      .click(function(){
        var sure = confirm('Generate new full sequence? this will take around 20 minutes.')
        if(!sure){ return }
        generateSequence('full-sequence',function(error,success){
          if(error){
            alert('Generating full sequence failed, try again.')
          } else {
            alert('Generating full sequence started...')
          }
        })
        menu.remove()
      })
    return dateButton
  }

  var generateRefreshReports = function(){
    var refreshButton =
      button(`refresh reports`,'fi-refresh')
      .css({
        display: 'block',
      })
      .click(function(){
        refreshReports(function(error,success){
          if(error){
            alert('Refreshing reports failed, try again.')
          } else {
            alert('Refreshing reports completed.')
          }
        })
        menu.remove()
      })
    return refreshButton
  }

  var generateRefreshCdn = function(frontendType){
    var refreshCdnButton =
      button(`refresh cdn`,'fi-refresh')
      .css({
        display: 'block',
      })
      .click(function(){
        refreshCdn(o, frontendType, function(error){
          if(error){
            alert('Refreshing cdn failed, try again.')
          } else {
            alert('Refreshing cdn completed.')
          }
        })
        menu.remove()
      })
    return refreshCdnButton
  }

  var click = function(){

    var overlay =
      $('<div>')
      .css({
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
      })
      .click(function(){
        menu.remove()
      })

    var buttons =
      $('<div>')
      .css({
        position: 'absolute',
        right: '34px',
        top: '34px',
      })
      .append([
        generateRefresh()
      ])

    if(Config.resolutions[360]){
      buttons.append([generateDownloadButton('360')])
    }

    if(Config.resolutions[480]){
      buttons.append([generateDownloadButton('480')])
    }

    if(Config.resolutions[720]){
      buttons.append([generateDownloadButton('720')])
    }

    if(Config.resolutions[1080]){
      buttons.append([generateDownloadButton('1080')])
    }

    if(Config.keyCdn.active){
      buttons.append([
        generateRefreshCdn('archive'),
        generateRefreshCdn('content'),
        generateRefreshCdn('aaTags'),
      ])
    }

    buttons.append([
      generateDownloadCsvButton('report_clicks_by_tag'),
      generateDownloadCsvButton('report_users_by_day'),
      generateDownloadCsvButton('report_visits_by_day'),
      generateDownloadCsvButton('report_archive_workers'),
      generateRefreshReports(),
      generateDownloadCsvDataButton(),
    ])

    menu =
      $('<div>')
      .css({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      })
      .append([
        overlay,
        buttons,
      ])

    $('body')
    .append(menu)

  }

  var div =
    button(null,'custom-gear')
    .css({
      position: 'absolute',
      display: 'inline-block',
      right: '34px',
    })
    .attr({
      title: 'Last full sequence generated successfully at ' + date + '.',
    })
    .click(click)

  if (o.store('role') == "admin"){
    return div
  } else {
    return
  }

}



// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/settings/settings.js